navigator.sayswho = (function () {
  var ua = navigator.userAgent, tem,
    M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
  if (/trident/i.test(M[1])) {
    tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
    return 'IE ' + (tem[1] || '');
  }
  if (M[1] === 'Chrome') {
    tem = ua.match(/\b(OPR|Edge)\/(\d+)/);
    if (tem != null)
      return tem.slice(1).join(' ').replace('OPR', 'Opera');
  }
  M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?'];
  if ((tem = ua.match(/version\/(\d+)/i)) != null)
    M.splice(1, 1, tem[1]);
  return M[0];
})();


function launchIntoFullscreen(element) {
  if (element.requestFullscreen) {
    element.requestFullscreen();
  } else if (element.mozRequestFullScreen) {
    element.mozRequestFullScreen();
  } else if (element.webkitRequestFullscreen) {
    element.webkitRequestFullscreen();
  } else if (element.msRequestFullscreen) {
    element.msRequestFullscreen();
  }
}
// Whack fullscreen
function exitFullscreen(document) {
  if (document.exitFullscreen) {
    document.exitFullscreen();
  } else if (document.mozCancelFullScreen) {
    document.mozCancelFullScreen();
  } else if (document.webkitExitFullscreen) {
    document.webkitExitFullscreen();
  }
}

jQuery(document).ready(function ($) {
  var videoPlayer = $('#videoPlayer');
  $('.btn-videoplay').click(function (e) {

    if (videoPlayer[0].paused) {
      videoPlayer[0].play();
      $('.fa-play').attr('class', 'fa fa-pause');
      //$('#video-container').show();
      $('.html5-video-front-end').hide();
      $('.html5-video-back-end').show();
      $('.video-btn-holder').show();
      //launchIntoFullscreen(videoPlayer[0]);
    } else {
      videoPlayer[0].pause();
      $('.fa-pause').attr('class', 'fa fa-play');
    }
    videoPlayer[0].addEventListener('ended', function () {
      videoPlayer[0].currentTime = '0';
      videoPlayer[0].pause();
      $('.fa-pause').attr('class', 'fa fa-play');
      // $('#video-container').hide();
      // $('.poster-image').show();            
      // $('.video-btn-holder').hide();
      // $('.close-video').hide();
      $('.html5-video-front-end').show();
      $('.html5-video-back-end').hide();
      $('.video-btn-holder').hide();

      exitFullscreen(videoPlayer[0]);
    });

    e.preventDefault();
    return false;
  });
  $('.btn-videostop').click(function (e) {
    videoPlayer[0].pause();
    videoPlayer[0].currentTime = 0;
    $('.fa-pause').attr('class', 'fa fa-play');
    //$('#video-container').hide();
    //$('.poster-image').show();
    //$('.video-btn-holder').hide();
    //$('.close-video').hide();
    $('.html5-video-front-end').show();
    $('.html5-video-back-end').hide();
    $('.video-btn-holder').hide();

    e.preventDefault();
    return false;
  });
  videoPlayer.on('timeupdate', function () {
    var currentPos = videoPlayer[0].currentTime;
    var maxduration = videoPlayer[0].duration;
    var perc = 100 * currentPos / maxduration;
    $('#progressBar').css('width', perc + '%');
    $('#timeWrap .currentTime').html(toHHMMSS(currentPos));
    $('#timeWrap .duration').html(toHHMMSS(maxduration));
    $('#timeWrap').css({ 'display': 'inline-block' });
  });
  videoPlayer.on('loadedmetadata', function (e) {
    //setTimeout(startBuffer, 150);
  });

  //display video buffering bar
  var startBuffer = function () {
    var currentBuffer = videoPlayer[0].buffered.end(0);
    var maxduration = videoPlayer[0].duration;
    var perc = 100 * currentBuffer / maxduration;
    $('.bufferBar').css('width', perc + '%');
    if (currentBuffer < maxduration) {
      setTimeout(startBuffer, 500);
    }
  };
  $('.btn-videomute').click(function (e) {
    if (videoPlayer[0].muted == false) {
      videoPlayer[0].muted = true;
      $('.glyphicon-volume-up').attr('class', 'glyphicon glyphicon-volume-off');
    } else {
      videoPlayer[0].muted = false;
      $('.glyphicon-volume-off').attr('class', 'glyphicon glyphicon-volume-up');
    }
    e.preventDefault();
  });
  $('.btnFullscreen').on('click', function (e) {
    launchIntoFullscreen(videoPlayer[0]);
    /*if (navigator.sayswho.toLowerCase() == 'chrome') {
     videoPlayer[0].webkitEnterFullscreen();
     }
     if (navigator.sayswho.toLowerCase() == 'firefox') {
     videoPlayer[0].mozRequestFullScreen();
     }*/
    //e.preventDefault();
    return false;
  });
  //VIDEO PROGRESS BAR
  //when video timebar clicked
  var timeDrag = false; /* check for drag event */
  $('#defaultBar').on('mousedown', function (e) {
    timeDrag = true;
    updatebar(e.pageX);
  });
  $(document).on('mouseup', function (e) {
    if (timeDrag) {
      timeDrag = false;
      updatebar(e.pageX);
    }
  });
  $(document).on('mousemove', function (e) {
    if (timeDrag) {
      updatebar(e.pageX);
    }
  });
  var updatebar = function (x) {
    var progress = $('#defaultBar');
    //calculate drag position
    //and update video currenttime
    //as well as progress bar
    var maxduration = videoPlayer[0].duration;
    var position = x - progress.offset().left;
    var percentage = 100 * position / progress.width();
    if (percentage > 100) {
      percentage = 100;
    }
    if (percentage < 0) {
      percentage = 0;
    }
    $('#progressBar').css('width', percentage + '%');
    videoPlayer[0].currentTime = maxduration * percentage / 100;
  };
  resizeToCover();
});

function toHHMMSS(str) {
  var sec_num = parseInt(str, 10); // don't forget the second param
  var hours = Math.floor(sec_num / 3600);
  var minutes = Math.floor((sec_num - (hours * 3600)) / 60);
  var seconds = sec_num - (hours * 3600) - (minutes * 60);
  if (hours < 10) {
    hours = "0" + hours;
  }
  if (minutes < 10) {
    minutes = "0" + minutes;
  }
  if (seconds < 10) {
    seconds = "0" + seconds;
  }
  var time = minutes + ':' + seconds;
  return time;
}

function resizeToCover() {
  var min_w = 300;
  var target_video = jQuery('#videoPlayer');

  vid_w_orig = parseInt(target_video.attr('width'));
  vid_h_orig = parseInt(target_video.attr('height'));
  // set the video viewport to the window size
  jQuery('#video-container').width(jQuery(window).width());
  jQuery('#video-container').height(jQuery(window).height());

  // use largest scale factor of horizontal/vertical
  var scale_h = jQuery(window).width() / vid_w_orig;
  var scale_v = jQuery(window).height() / vid_h_orig;
  var scale = scale_h < scale_v ? scale_h : scale_v;

  // don't allow scaled width < minimum video width
  if (scale * vid_w_orig < min_w) {
    scale = min_w / vid_w_orig;
  }

  // now scale the video
  target_video.width(scale * vid_w_orig);
  target_video.height(scale * vid_h_orig);

  // and center it by scrolling the video viewport
  $('#video-container').scrollLeft((target_video.width() - jQuery(window).width()) / 2);
  $('#video-container').scrollTop((target_video.height() - jQuery(window).height()) / 2);
}

jQuery(document).ready(function ($) {
  if ($('#vimeo_iframe').length) {
    var iframe = document.getElementById('vimeo_iframe');
    var iframePlayer = new Vimeo.Player(iframe);
    iframePlayer.setVolume(0);
    iframePlayer.setLoop(true);
    $('.btn-vimeo-play').click(function (e) {
      iframePlayer.play();
      $('.html5-video-front-end').hide();
      $('.html5-video-back-end').show();
      e.preventDefault();
      return false;
    });
    $('.btn-vimeo-stop').click(function (e) {
      iframePlayer.pause();
      $('.html5-video-front-end').show();
      $('.html5-video-back-end').hide();
      e.preventDefault();
      return false;
    });
  }
});
